export default __webpack_public_path__ + "static/media/25.b1b22e6b.jpg";